<template>
  <div style="width:90vw;margin-left:auto;margin-right:auto;">
    <ul class="list-unstyled">
      <li class="card-header" style="padding-left: 0; padding-top: 0.25rem; padding-right: 0; padding-bottom: 0.25rem; background-color: #fff" v-for="dtoUser in dtoFollow.followList" :key="dtoUser.id">
        <UserBlock :dtoUser="dtoUser"></UserBlock>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import FollowResp from "@/interface/api/FollowResp";
import UserResp from "@/interface/api/UserResp";
import UserBlock from "@/component/parts/UserBlock.vue";

@Options({
  components: {
    UserBlock,
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  dtoFollow: FollowResp = {
    user: { displayName: "" } as UserResp,
    followList: [],
    followedList: [],
  };
  getActiveClass(name:string){
    return this.$route.name === name ? "active" : '';
  }

  // フォロー一覧を取得
  getFollowList() {
    this.$root.restAccess.getFollowList(this.$route.params.userName as string).then((res) => {
      // console.log(res);
      if (res.status >= 400) {
        return;
      }
      res.json().then((data) => {
        console.log(data);
        this.dtoFollow = data;
      });
    });
  }

  init() {
    document.title = "フォロー：" + this.$route.params.userName;
    this.getFollowList();
  }

  onLonginChanged() {
    this.init();
  }

  created() {
    this.$root.account.addLoginListener(this.onLonginChanged)
    this.init();
  }
  
  beforeUnmount(){
    this.$root.account.removeLoginListener(this.onLonginChanged)
  }
}
</script>

<style lang="scss" scoped>

.list-unstyled {
    padding-left: 0;
    list-style: none;
}
</style>

